// requestIdelCallback will schedule work when there is free time at the end of a frame, or when the user is inactive.
// https://developer.chrome.com/blog/using-requestidlecallback#checking_for_requestidlecallback
export const requestIdleCallback =
  (typeof self !== 'undefined' && self.requestIdleCallback && self.requestIdleCallback.bind(window)) ||
  function (cb: IdleRequestCallback): number {
    const start = Date.now();
    return self.setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining() {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

export const cancelIdleCallback =
  (typeof self !== 'undefined' && self.cancelIdleCallback && self.cancelIdleCallback.bind(window)) ||
  function (id: number) {
    return clearTimeout(id);
  };
